import { Suspense } from 'react';
import { createFileRoute } from '@tanstack/react-router';
import { ErrorBoundary } from '@/components/common/ErrorBoundary';
import { PageLoader } from '@/components/common/PageLoader';
import { FeedbackListPage } from '@/features/feedback/pages/FeedbackListPage';

export const Route = createFileRoute('/_auth/feedback/list')({
  component: () => (
    <ErrorBoundary moduleName="Feedbacks">
      <Suspense fallback={<PageLoader />}>
        <FeedbackListPage />
      </Suspense>
    </ErrorBoundary>
  ),
});
